import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../lib/supabase';

const NAVY = '#0F2A4A';
const GOLD = '#D4AF37';
const SILVER = '#64748B';

export default function VerifyEmail() {
  const { user, signOut } = useAuth();
  const [resent, setResent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleResend = async () => {
    setError('');
    setLoading(true);
    try {
      const { error } = await supabase.auth.resend({
        type: 'signup',
        email: user?.email,
      });
      if (error) throw error;
      setResent(true);
    } catch (err) {
      setError(err.message || 'Failed to resend email.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      backgroundColor: NAVY, padding: '1rem'
    }}>
      <div style={{
        backgroundColor: 'white', borderRadius: 12, padding: '2.5rem',
        width: '100%', maxWidth: 440, boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
        textAlign: 'center'
      }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}>📬</div>
        <div style={{ fontSize: 28, fontWeight: 800, color: NAVY, marginBottom: 8 }}>
          BE<span style={{ color: GOLD }}>Civitas</span>
        </div>
        <h2 style={{ color: NAVY, fontWeight: 700, fontSize: 20, margin: '0 0 12px' }}>Check Your Email</h2>
        <p style={{ color: SILVER, fontSize: 15, lineHeight: 1.6, marginBottom: 24 }}>
          We sent a verification link to <strong>{user?.email}</strong>.
          Please click the link in that email to activate your account and gain access to Civitas.
        </p>

        {error && (
          <div style={{
            backgroundColor: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 8,
            padding: '0.75rem 1rem', marginBottom: '1rem', color: '#991B1B', fontSize: 14
          }}>{error}</div>
        )}

        {resent ? (
          <div style={{
            backgroundColor: '#F0FDF4', border: '1px solid #BBF7D0', borderRadius: 8,
            padding: '0.75rem 1rem', marginBottom: '1rem', color: '#166534', fontSize: 14
          }}>✅ Verification email resent!</div>
        ) : (
          <button
            onClick={handleResend} disabled={loading}
            style={{
              width: '100%', padding: '0.75rem', borderRadius: 8, border: 'none',
              backgroundColor: GOLD, color: NAVY, fontWeight: 700, fontSize: 15,
              cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1,
              marginBottom: '1rem'
            }}
          >
            {loading ? 'Sending…' : 'Resend Verification Email'}
          </button>
        )}

        <button
          onClick={signOut}
          style={{
            background: 'none', border: 'none', color: SILVER, fontSize: 14,
            cursor: 'pointer', textDecoration: 'underline'
          }}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
